<template>
  <div
    class="col-12 lg-col-8 md-col-12 sm-col-8 xs-col-12 flex p2 center justify-center"
  >
    <div class="flex flex-wrap flex-column justify-between items-center col-12">
      <!-- Ticket Name -->
      <ticket-item-info :billet="billet" />

      <div
        v-if="
          (billet.contremarque || billet.order_contremarque) &&
          (['single-entry'].includes(billet.type) || billet.inscription) &&
          billet.endDate
        "
        class="flex justify-center mt2"
      >
        <span class="h7n">Date de fin de validité: </span>
        <div class="ml1 h7n">
          {{ billet.endDate }}
        </div>
      </div>

      <ticket-item-reservation :billet="billet" />

      <div class="flex flex-column py2">
        <span class="caps block dark-blue h7n">Participant</span>
        <h3 class="my0 h6n regular">
          <i class="icon icon-profile mr1"></i>{{ billet.customer.firstname }}
          {{ billet.customer.lastname }}
        </h3>
      </div>

      <div
        tabindex="0"
        role="button"
        class="flex justify-center border pointer rounded p1 hover"
        style="height: 40px"
        @click="goToTicketInfo(billet)"
      >
        <div class="flex items-center">
          <i class="icon icon-add-more-icon"></i>
          <h3 class="inline-block my0 h7n ml1">informations et options</h3>
        </div>
      </div>

      <ticket-sessions
        :billet="billet"
        :extraId="'regular'"
        class="md-hide xs-hide"
      />
    </div>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import TicketItemInfo from "./TicketItemInfo.vue";
import TicketItemReservation from "./TicketItemReservation.vue";
import TicketSessions from "./TicketSessions.vue";

export default {
  components: {
    TicketItemInfo,
    TicketItemInfo,
    TicketItemReservation,
    TicketSessions
  },
  props: {
    billet: {
      type: Object,
      required: true
    }
  },
  setup({ billet }) {
    const router = useRouter();

    const goToTicketInfo = async () => {
      router.push({
        name: "TicketInfo",
        params: { qrcode: billet.qrcode }
      });
    };

    return {
      goToTicketInfo
    };
  }
};
</script>